import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=3fdc357b&scoped=true"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestion.vue?vue&type=style&index=0&id=3fdc357b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc357b",
  null
  
)

export default component.exports